import { combineReducers } from "redux";
import constant from "lodash-es/constant";

import createReducer from "../../utils/createReducer";

import {
  REQUEST_SEARCH_INCIDENT_TYPES,
  REQUEST_SEARCH_INCIDENT_TYPES_SUCCESS,
  REQUEST_SEARCH_INCIDENT_TYPES_FAIL
} from "./actionTypes";

// Places Data
const data = createReducer(null, {
  [REQUEST_SEARCH_INCIDENT_TYPES]: constant(null),
  [REQUEST_SEARCH_INCIDENT_TYPES_SUCCESS]: (state, { payload }) => payload,
  [REQUEST_SEARCH_INCIDENT_TYPES_FAIL]: constant(null)
});

const error = createReducer(null, {
  [REQUEST_SEARCH_INCIDENT_TYPES]: constant(null),
  [REQUEST_SEARCH_INCIDENT_TYPES_SUCCESS]: constant(null),
  [REQUEST_SEARCH_INCIDENT_TYPES_FAIL]: (state, { payload }) => payload
});

const isLoading = createReducer(false, {
  [REQUEST_SEARCH_INCIDENT_TYPES]: constant(true),
  [REQUEST_SEARCH_INCIDENT_TYPES_SUCCESS]: constant(false),
  [REQUEST_SEARCH_INCIDENT_TYPES_FAIL]: constant(false)
});

export default combineReducers({
  data,
  error,
  isLoading
});
